// extracted by mini-css-extract-plugin
export default {"skillCard":"SkillCard_skillCard__PN+AL","skillIcon":"SkillCard_skillIcon__JYR62","skillName":"SkillCard_skillName__NMwTM"};